<template>
    <v-container class="fill-height fluid">
        <v-img src="../assets/background-large.png" style="width:100%; height:100%; position:absolute; top:0; left:0;"></v-img>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">

                <v-card elevation="12">
                    <v-card-title class="white--text" :style="{background: appColors.background}">
                        Passord reset
                    </v-card-title>
                    <v-card-text class="pt-5">
                        <v-form ref="form">
                            <v-text-field v-model="token" label="token" :tabindex="-1" readonly filled></v-text-field>

                            <v-text-field v-model="password" autofocus label="passord" :tabindex="1" filled clearable :type="showPassword? 'text' : 'password'" :append-icon="showPassword? 'mdi-eye-off' : 'mdi-eye'" @click:append="toggleShowPassword" :rules="[ rules.required, rules.passwordCheck ]"></v-text-field>
                            <v-text-field v-model="passwordRepeat" label="gjenta passord" :tabindex="2" filled clearable :type="showPassword? 'text' : 'password'" :rules="[ rules.required, rules.passwordCheck ]"></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text color="#CCCCCC" small @click="login">
                            <v-icon left>mdi-login</v-icon>
                            Logg inn
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" :tabindex="3" @click="resetPassword">
                            Nullstil passord
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
import { colors as appColors } from "../utilities/colors";

export default {
    props: ["token"],
    data() {
        return {
            appColors,
            showPassword: false,
            password: undefined,
            passwordRepeat: undefined,
            rules: {
                required: value => !!value || "Påkrevd",
                passwordCheck: () => this.password === this.passwordRepeat || "Ulike passord"
            }
        };
    },
    methods: {
        toggleShowPassword: function() {
            this.showPassword = !this.showPassword;
        },
        resetPassword: async function() {
            // debugger;
            if (!this.$refs.form.validate()) {
                return;
            }

            let response = await axios.post("/authenticate/passwordreset", { token: this.token, password: this.password });
            if (response.status == 200) {
                this.$router.push({ name: "login" });
            }
        },
        login: function() {
            this.$router.push({ name: "login" });
        }
    },
    watch: {
        password: function() {
            this.$refs.form.validate();
        },
        passwordRepeat: function() {
            this.$refs.form.validate();
        }
    },
    mounted() {
        // console.log(this.token);
    }
};
</script>

<style lang="scss">
</style>